/** The scope trigger's two shapes, as style objects. Their own module so
 *  the trigger component holds only markup. */
import type { CSSProperties } from 'react';

/** The phone trigger: a pill, sized to be tapped. */
export const SCOPE_TRIGGER_PILL: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  minHeight: 32,
  maxWidth: '100%',
  padding: '0 6px 0 10px',
  borderRadius: 999,
  cursor: 'pointer',
  background: 'var(--nb-primary-soft)',
  border: '1px solid var(--nb-border)',
  color: 'var(--nb-primary-2)',
  fontSize: 12.5,
  fontWeight: 600,
};

/** The wide trigger: an eyebrow beside the title. */
export const SCOPE_TRIGGER_EYEBROW: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  background: 'transparent',
  border: 0,
  padding: 0,
  cursor: 'pointer',
  font: 'inherit',
  letterSpacing: 'inherit',
  textTransform: 'inherit',
  color: 'var(--nb-subtle)',
};
